import { HttpContextToken, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { I18nService } from '../i18n.service';
import { __ } from '../../functions/object.functions';

/**
 * An HTTP interceptor that adds the accept language header to the request headers.
 *
 * @param req The HTTP request to intercept.
 * @param next The next handler in the chain.
 * @returns An observable of the HTTP event.
 */
export function acceptLanguageInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  if (req.context.get(ACCEPT_LANGUAGE_DISABLED)) {
    return next(req);
  }

  const i18nService = inject(I18nService);

  if (
    __.IsNullOrUndefinedOrEmpty(i18nService) &&
    __.IsNullOrUndefinedOrEmpty(i18nService.language)
  ) {
    return next(req);
  }

  return next(
    req.clone({
      headers: req.headers.set('Accept-Language', i18nService.language),
    }),
  );
}

/**
 * A context token to disable the accept language interceptor for specific requests.
 */
export const ACCEPT_LANGUAGE_DISABLED = new HttpContextToken<boolean>(() => false);
